import React from 'react';
import * as PropTypes from 'prop-types';

import SimpleMenuItem from './SimpleItem';
import ComplexMenuItem from './ComplexItem';

function MenuItem(props) {
  const { submenu } = props || {};

  if (submenu) {
    return <ComplexMenuItem {...props} />;
  }

  return <SimpleMenuItem {...props} />;
}

MenuItem.propTypes = {
  submenu: PropTypes.object,
  active: PropTypes.bool,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  danger: PropTypes.bool,
  borderTop: PropTypes.bool,
  id: PropTypes.string,
};

export default MenuItem;



// WEBPACK FOOTER //
// ./src/components/common/IconMenu/MenuItem/index.jsx